module.exports = __webpack_public_path__ + "img/operasyonel-mukemmellik.0224cf77.png";